import {setupAxios} from '../app/modules/auth'
import {api} from './APIMiddlewares'
import API from './APIUrl'

// form save api integration
export async function addDesignation(InputField: {designationName: string}) {
  const {token, tenantId} = setupAxios()

  return await api
    .post(
      `/${API.DESIGNATION}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          name: InputField.designationName,
        }),
      },
      false
    )
    .then((res) => res)
}

//edit by id
export async function updateDesignationById(
  InputField: {
    designationName: string
  },
  id: string
) {
  const {token, tenantId} = setupAxios()
  return await api
    .put(
      `/${API.DESIGNATION}/${id}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          name: InputField.designationName,
        }),
      },
      false
    )
    .then((res) => res)
}

//   get Holiday

export async function getDesignations() {
  const {token, tenantId} = setupAxios()
  return await api.get(`/${API.DESIGNATION}`, token, tenantId, false)
}

//   delete holiday

export async function deleteDesignations(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.delete(`/${API.DESIGNATION}/${id}`, token, tenantId, false)
}

//getHolidaybyid

export async function getDesignationsById(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/${API.DESIGNATION}/${id}`, token, tenantId, false)
}
